import {
  GET_INVOICE_HISTORY,
  GET_INVOICE_HISTORY_FAIL,
  GET_INVOICE_HISTORY_SUCCESS,
  ADD_NEW_INVOICE_HISTORY,
  ADD_INVOICE_HISTORY_SUCCESS,
  ADD_INVOICE_HISTORY_FAIL,
  UPDATE_INVOICE_HISTORY,
  UPDATE_INVOICE_HISTORY_SUCCESS,
  UPDATE_INVOICE_HISTORY_FAIL,
  DELETE_INVOICE_HISTORY,
  DELETE_INVOICE_HISTORY_SUCCESS,
  DELETE_INVOICE_HISTORY_FAIL,
  GET_INVOICE_HISTORY_DETAIL,
  SET_INVOICE_HISTORY_LOADING,
} from "./actionTypes"

export const getInvoiceHistoryes = props => ({
  type: GET_INVOICE_HISTORY,
  payload: props,

})

export const getInvoiceHistoryesSuccess = invoiceHistoryes => ({
  type: GET_INVOICE_HISTORY_SUCCESS,
  payload: invoiceHistoryes,
})

export const getInvoiceHistoryesFail = error => ({
  type: GET_INVOICE_HISTORY_FAIL,
  payload: error,
})


export const setInvoiceHistoryLoading = () => ({
  type: SET_INVOICE_HISTORY_LOADING,
  // payload: invoiceHistory,
})

export const addNewInvoiceHistory = invoiceHistory => ({
  type: ADD_NEW_INVOICE_HISTORY,
  payload: invoiceHistory,
})

export const addInvoiceHistorySuccess = invoiceHistory => ({
  type: ADD_INVOICE_HISTORY_SUCCESS,
  payload: invoiceHistory,
})

export const addInvoiceHistoryFail = error => ({
  type: ADD_INVOICE_HISTORY_FAIL,
  payload: error,
})

export const updateInvoiceHistory = invoiceHistory => ({
  type: UPDATE_INVOICE_HISTORY,
  payload: invoiceHistory,
})

export const updateInvoiceHistorySuccess = invoiceHistory => ({
  type: UPDATE_INVOICE_HISTORY_SUCCESS,
  payload: invoiceHistory,
})

export const updateInvoiceHistoryFail = error => ({
  type: UPDATE_INVOICE_HISTORY_FAIL,
  payload: error,
})

export const deleteInvoiceHistory = invoiceHistory => ({
  type: DELETE_INVOICE_HISTORY,
  payload: invoiceHistory,
})

export const deleteInvoiceHistorySuccess = invoiceHistory => ({
  type: DELETE_INVOICE_HISTORY_SUCCESS,
  payload: invoiceHistory,
})

export const deleteInvoiceHistoryFail = error => ({
  type: DELETE_INVOICE_HISTORY_FAIL,
  payload: error,
})

export const getInvoiceHistoryDetails = invoiceHistory => ({
  type: GET_INVOICE_HISTORY_DETAIL,
  payload: invoiceHistory,
})

export const getInvoiceHistoryDetailFail = error => ({
  type: GET_INVOICE_HISTORY_DETAIL_FAIL,
  payload: error,
})


export const getInvoiceHistoryDetailSuccess = invoiceHistory => ({
  type: GET_INVOICE_HISTORY_DETAIL_SUCCESS,
  payload: invoiceHistory,
})


